module.exports = __webpack_public_path__ + "static/media/logo-icon-small.9b93b054.svg";